export enum PhotoType {
  Front = 1,
  Back = 2,
  Diagonal = 3
}

export default PhotoType;
